import { createAction } from '@reduxjs/toolkit';

const ACTION_PREFIX = 'users';

export const fetchUserSummary = createAction(`${ACTION_PREFIX}/FETCH_USER_SUMMARY`);
export const fetchUserSummaryRequest = createAction(`${ACTION_PREFIX}/FETCH_USER_SUMMARY_REQUEST`);
export const fetchUserSummarySuccess = createAction(`${ACTION_PREFIX}/FETCH_USER_SUMMARY_SUCCESS`);
export const fetchUserSummaryFailed = createAction(`${ACTION_PREFIX}/FETCH_USER_SUMMARY_FAILED`);

export const onUserFilterChange = createAction(`${ACTION_PREFIX}/ON_USER_FILTER_CHANGE`);

export const adminHandle = createAction(`${ACTION_PREFIX}/ADMIN_HANDLER`);
export const adminHandleSucceeded = createAction(`${ACTION_PREFIX}/ADMIN_HANDLER_SUCCEEDED`);
export const adminHandleFailed = createAction(`${ACTION_PREFIX}/ADMIN_HANDLER_FAILED`);

export const usersFetch = createAction(`${ACTION_PREFIX}/FETCH_USERS`);
export const usersFetchRequest = createAction(`${ACTION_PREFIX}/FETCH_USERS_REQUEST`);
export const usersFetchSucceeded = createAction(`${ACTION_PREFIX}/FETCH_USERS_SUCCEEDED`);
export const usersFetchFailed = createAction(`${ACTION_PREFIX}/FETCH_USERS_FAILED`);

export const changeUserStatus = createAction(`${ACTION_PREFIX}/CHANGE_USER_STATUS`);
export const changeUserStatusSucceeded = createAction(`${ACTION_PREFIX}/CHANGE_USER_STATUS_SUCCEEDED`);
export const changeUserStatusFailed = createAction(`${ACTION_PREFIX}/CHANGE_USER_STATUS_FAILED`);

export const assignToSearch = createAction(`${ACTION_PREFIX}/ASSIGN_TO_SEARCH`);
export const assignToSearchSucceeded = createAction(`${ACTION_PREFIX}/ASSIGN_TO_SEARCH_SUCCEEDED`);
export const assignToSearchFailed = createAction(`${ACTION_PREFIX}/ASSIGN_TO_SEARCH_FAILED`);

export const unassignToSearch = createAction(`${ACTION_PREFIX}/UNASSIGN_TO_SEARCH`);
export const unassignToSearchSucceeded = createAction(`${ACTION_PREFIX}/UNASSIGN_TO_SEARCH_SUCCEEDED`);
export const unassignToSearchFailed = createAction(`${ACTION_PREFIX}/UNASSIGN_TO_SEARCH_FAILED`);

export const editProfile = createAction(`${ACTION_PREFIX}/EDIT_PROFILE`);
export const editProfileSucceeded = createAction(`${ACTION_PREFIX}/EDIT_PROFILE_SUCCEEDED`);
export const editProfileFailed = createAction(`${ACTION_PREFIX}/EDIT_PROFILE_FAILED`);

export const assignToTeams = createAction(`${ACTION_PREFIX}/ASSIGN_TO_TEAMS`);
export const assignToTeamsSucceeded = createAction(`${ACTION_PREFIX}/ASSIGN_TO_TEAMS_SUCCEEDED`);
export const assignToTeamsFailed = createAction(`${ACTION_PREFIX}/ASSIGN_TO_TEAMS_FAILED`);

export const resetPassword = createAction(`${ACTION_PREFIX}/RESET_PASSWORD`);
export const resetPasswordSucceeded = createAction(`${ACTION_PREFIX}/RESET_PASSWORD_SUCCEEDED`);
export const resetPasswordFailed = createAction(`${ACTION_PREFIX}/RESET_PASSWORD_FAILED`);

export const removeUser = createAction(`${ACTION_PREFIX}/REMOVE_USER`);
export const removeUserSucceeded = createAction(`${ACTION_PREFIX}/REMOVE_USER_SUCCEEDED`);
export const removeUserFailed = createAction(`${ACTION_PREFIX}/REMOVE_USER_FAILED`);

export const createUser = createAction(`${ACTION_PREFIX}/CREATE_USER`);
export const createUserSucceeded = createAction(`${ACTION_PREFIX}/CREATE_USER_SUCCEEDED`);
export const createUserFailed = createAction(`${ACTION_PREFIX}/CREATE_USER_FAILED`);

export const clickedAddUserButton = createAction(`${ACTION_PREFIX}/CLICKED_ADD_USER_BUTTON`);
export const clickedEditUserButton = createAction(`${ACTION_PREFIX}/CLICKED_EDIT_USER_BUTTON`);
export const clickedResetPasswordButton = createAction(`${ACTION_PREFIX}/CLICKED_RESET_PASSWORD_BUTTON`);
export const clickedRemoveUserButton = createAction(`${ACTION_PREFIX}/CLICKED_REMOVE_USER_BUTTON`);
export const clickedRemoveUsersButton = createAction(`${ACTION_PREFIX}/CLICKED_REMOVE_USERS_BUTTON`);
export const clickedResendInviteButton = createAction(`${ACTION_PREFIX}/CLICKED_RESEND_INVITE_BUTTON`);
export const clickedRemoveInviteButton = createAction(`${ACTION_PREFIX}/CLICKED_REMOVE_INVITE_BUTTON`);
export const clickedUpdatePermissionsButton = createAction(`${ACTION_PREFIX}/CLICKED_UPDATE_PERMISSIONS_BUTTON`);
export const clickedUploadUsersListButton = createAction(`${ACTION_PREFIX}/CLICKED_UPLOAD_USERS_LIST_BUTTON`);
export const clickedAssignToTeamsButton = createAction(`${ACTION_PREFIX}/CLICKED_ASSIGN_TO_TEAMS_BUTTON`);
export const clickedSendReminders = createAction(`${ACTION_PREFIX}/CLICKED_SEND_REMINDERS_BUTTON`);
export const clickedCreateTeamButton = createAction(`${ACTION_PREFIX}/CLICKED_CREATE_TEAM_BUTTON`);
export const clickedRenameTeamButton = createAction(`${ACTION_PREFIX}/CLICKED_RENAME_TEAM_BUTTON`);
export const clickedDeleteTeamButton = createAction(`${ACTION_PREFIX}/CLICKED_DELETE_TEAM_BUTTON`);
export const clickedDisableTeamManagementButton = createAction(
  `${ACTION_PREFIX}/CLICKED_DISABLE_TEAM_MANAGEMENT_BUTTON`,
);
export const clickedBulkAssignToTeamsButton = createAction(`${ACTION_PREFIX}/CLICKED_BULK_ASSIGN_TO_TEAMS_BUTTON`);
export const clickGetStartedUploadUserList = createAction(`${ACTION_PREFIX}/CLICKED_GET_STARTED_UPLOAD_USER_LIST`);

export const clickedCloseModalButton = createAction(`${ACTION_PREFIX}/CLICKED_CLOSE_MODAL_BUTTON`);

export const copyActivationLink = createAction(`${ACTION_PREFIX}/COPY_ACTIVATION_LINK`);
export const copyActivationLinkSucceeded = createAction(`${ACTION_PREFIX}/COPY_ACTIVATION_LINK_SUCCEEDED`);
export const copyActivationLinkFailed = createAction(`${ACTION_PREFIX}/COPY_ACTIVATION_LINK_FAILED`);

export const exportUserList = createAction(`${ACTION_PREFIX}/EXPORT_USER_LIST`);
export const exportUserListSucceeded = createAction(`${ACTION_PREFIX}/EXPORT_USER_LIST_SUCCEEDED`);
export const exportUserListFailed = createAction(`${ACTION_PREFIX}/EXPORT_USER_LIST_FAILED`);

export const inviteUser = createAction(`${ACTION_PREFIX}/INVITE_USER`);
export const inviteUserSucceeded = createAction(`${ACTION_PREFIX}/INVITE_USER_SUCCEEDED`);
export const inviteUserFailed = createAction(`${ACTION_PREFIX}/INVITE_USER_FAILED`);

export const checkInviteStatus = createAction(`${ACTION_PREFIX}/CHECK_INVITE_STATUS`);
export const checkInviteStatusSucceeded = createAction(`${ACTION_PREFIX}/CHECK_INVITE_STATUS_SUCCEEDED`);
export const checkInviteStatusFailed = createAction(`${ACTION_PREFIX}/CHECK_INVITE_STATUS_FAILED`);

export const resendInvite = createAction(`${ACTION_PREFIX}/RESEND_INVITE`);
export const resendInviteSucceeded = createAction(`${ACTION_PREFIX}/RESEND_INVITE_SUCCEEDED`);
export const resendInviteFailed = createAction(`${ACTION_PREFIX}/RESEND_INVITE_FAILED`);

export const removeInvite = createAction(`${ACTION_PREFIX}/REMOVE_INVITE`);
export const removeInviteSucceeded = createAction(`${ACTION_PREFIX}/REMOVE_INVITE_SUCCEEDED`);
export const removeInviteFailed = createAction(`${ACTION_PREFIX}/REMOVE_INVITE_FAILED`);

export const sendReminders = createAction(`${ACTION_PREFIX}/SEND_REMINDERS`);
export const sendRemindersSucceeded = createAction(`${ACTION_PREFIX}/SEND_REMINDERS_SUCCEEDED`);
export const sendRemindersFailed = createAction(`${ACTION_PREFIX}/SEND_REMINDERS_FAILED`);

export const deleteTeam = createAction(`${ACTION_PREFIX}/DELETE_TEAM`);
export const deleteTeamSucceeded = createAction(`${ACTION_PREFIX}/DELETE_TEAM_SUCCEEDED`);
export const deleteTeamFailed = createAction(`${ACTION_PREFIX}/DELETE_TEAM_FAILED`);

export const renameTeam = createAction(`${ACTION_PREFIX}/RENAME_TEAM`);
export const renameTeamSucceeded = createAction(`${ACTION_PREFIX}/RENAME_TEAM_SUCCEEDED`);
export const renameTeamFailed = createAction(`${ACTION_PREFIX}/RENAME_TEAM_FAILED`);

export const createTeam = createAction(`${ACTION_PREFIX}/CREATE_TEAM`);
export const createTeamSucceeded = createAction(`${ACTION_PREFIX}/CREATE_TEAM_SUCCEEDED`);
export const createTeamFailed = createAction(`${ACTION_PREFIX}/CREATE_TEAM_FAILED`);

export const setCurrentClickedUser = createAction(`${ACTION_PREFIX}/SET_CURRENT_CLICKED_USER`);

export const closeUserListPendingNotice = createAction(`${ACTION_PREFIX}/CLOSE_USER_LIST_PENDING_NOTICE`);

export const exportAudit = createAction(`${ACTION_PREFIX}/EXPORT_AUDIT`);
export const exportAuditSucceeded = createAction(`${ACTION_PREFIX}/EXPORT_AUDIT_SUCCEEDED`);
export const exportAuditFailed = createAction(`${ACTION_PREFIX}/EXPORT_AUDIT_FAILED`);

export const exportActivationIds = createAction(`${ACTION_PREFIX}/EXPORT_ACTIVATION_IDS`);
export const exportActivationIdsSucceeded = createAction(`${ACTION_PREFIX}/EXPORT_ACTIVATION_IDS_SUCCEEDED`);
export const exportActivationIdsFailed = createAction(`${ACTION_PREFIX}/EXPORT_ACTIVATION_IDS_FAILED`);

export const removeUsers = createAction(`${ACTION_PREFIX}/REMOVE_USERS`);
export const removeUsersSucceeded = createAction(`${ACTION_PREFIX}/REMOVE_USERS_SUCCEEDED`);
export const removeUsersFailed = createAction(`${ACTION_PREFIX}/REMOVE_USERS_FAILED`);

export const bulkAssignToTeams = createAction(`${ACTION_PREFIX}/BULK_ASSIGN_TO_TEAMS`);
export const bulkAssignToTeamsSucceeded = createAction(`${ACTION_PREFIX}/BULK_ASSIGN_TO_TEAMS_SUCCEEDED`);
export const bulkAssignToTeamsFailed = createAction(`${ACTION_PREFIX}/BULK_ASSIGN_TO_TEAMS_FAILED`);

export const validateCsvFile = createAction(`${ACTION_PREFIX}/VALIDATE_CSV_FILE`);
export const validateCsvFileSucceeded = createAction(`${ACTION_PREFIX}/VALIDATE_CSV_FILE_SUCCESS`);
export const validateCsvFileFailed = createAction(`${ACTION_PREFIX}/VALIDATE_CSV_FILE_FAILED`);

export const switchStageToUpload = createAction(`${ACTION_PREFIX}/SWITCH_STAGE_TO_UPLOAD`);
export const switchStageToSuccess = createAction(`${ACTION_PREFIX}/SWITCH_STAGE_TO_SUCCESS`);
export const closeSuccessModal = createAction(`${ACTION_PREFIX}/CLOSE_SUCCESS_MODAL`);

export const addUsersFromCsv = createAction(`${ACTION_PREFIX}/ADD_USERS_FROM_CSV`);
export const addUsersFromCsvSucceeded = createAction(`${ACTION_PREFIX}/ADD_USERS_FROM_CSV_SUCCESS`);
export const addUsersFromCsvFailed = createAction(`${ACTION_PREFIX}/ADD_USERS_FROM_CSV_FAILED`);

export const setUploadProgress = createAction(`${ACTION_PREFIX}/SET_UPLOAD_PROGRESS`);

export const UsersActions = {
  setCurrentClickedUser,
  onUserFilterChange,

  adminHandle,
  adminHandleSucceeded,
  adminHandleFailed,

  resetPassword,
  resetPasswordSucceeded,
  resetPasswordFailed,

  usersFetch,
  usersFetchRequest,
  usersFetchSucceeded,
  usersFetchFailed,

  changeUserStatus,
  changeUserStatusSucceeded,
  changeUserStatusFailed,

  assignToSearch,
  assignToSearchSucceeded,
  assignToSearchFailed,

  unassignToSearch,
  unassignToSearchSucceeded,
  unassignToSearchFailed,

  editProfile,
  editProfileSucceeded,
  editProfileFailed,

  assignToTeams,
  assignToTeamsSucceeded,
  assignToTeamsFailed,

  removeUser,
  removeUserSucceeded,
  removeUserFailed,

  createUser,
  createUserSucceeded,
  createUserFailed,

  clickedAddUserButton,
  clickedEditUserButton,
  clickedCloseModalButton,
  clickedResetPasswordButton,
  clickedRemoveUserButton,
  clickedRemoveUsersButton,
  clickedResendInviteButton,
  clickedRemoveInviteButton,
  clickedUpdatePermissionsButton,
  clickedUploadUsersListButton,
  clickedAssignToTeamsButton,
  clickedBulkAssignToTeamsButton,
  closeUserListPendingNotice,
  clickedSendReminders,
  clickedCreateTeamButton,
  clickedRenameTeamButton,
  clickedDeleteTeamButton,
  clickedDisableTeamManagementButton,
  clickGetStartedUploadUserList,

  exportUserList,
  exportUserListSucceeded,
  exportUserListFailed,

  fetchUserSummary,
  fetchUserSummaryRequest,
  fetchUserSummarySuccess,
  fetchUserSummaryFailed,

  inviteUser,
  inviteUserSucceeded,
  inviteUserFailed,

  checkInviteStatus,
  checkInviteStatusSucceeded,
  checkInviteStatusFailed,

  resendInvite,
  resendInviteSucceeded,
  resendInviteFailed,

  removeInvite,
  removeInviteSucceeded,
  removeInviteFailed,

  sendReminders,
  sendRemindersSucceeded,
  sendRemindersFailed,

  deleteTeam,
  deleteTeamSucceeded,
  deleteTeamFailed,

  renameTeam,
  renameTeamSucceeded,
  renameTeamFailed,

  createTeam,
  createTeamSucceeded,
  createTeamFailed,

  exportAudit,
  exportAuditSucceeded,
  exportAuditFailed,

  removeUsers,
  removeUsersSucceeded,
  removeUsersFailed,

  bulkAssignToTeams,
  bulkAssignToTeamsSucceeded,
  bulkAssignToTeamsFailed,

  exportActivationIds,
  exportActivationIdsSucceeded,
  exportActivationIdsFailed,

  copyActivationLink,
  copyActivationLinkSucceeded,
  copyActivationLinkFailed,

  validateCsvFile,
  validateCsvFileSucceeded,
  validateCsvFileFailed,

  switchStageToUpload,
  switchStageToSuccess,
  closeSuccessModal,

  addUsersFromCsv,
  addUsersFromCsvSucceeded,
  addUsersFromCsvFailed,

  setUploadProgress,
};
